import { Utils } from '@/libs/Utils'
import { usePathname, useRouter } from 'next/navigation'
import React from 'react'

interface SearchProps {
    locale: string
}

const Search: React.FC<SearchProps> = ({ locale }) => {

    const t = new Utils(locale).Translation
    const pathname = usePathname()
    const router = useRouter()

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const searchTxt = event.target.search.value

        if (!searchTxt) {
            return router.push(pathname)
        } else {
            const rgx = new RegExp('/page/[0-9]{0,99}', 'g')
            if (pathname.match(rgx) && !!pathname?.match(rgx)?.[0]) {
                return router.push(pathname?.replace(rgx, '') + '?' + `search=${searchTxt}`)
            }
            return router.push(pathname + '?' + `search=${searchTxt}`)
        }
    }


    return (
        <div className="container mb-5">
            <div className='row'>
                <div className='d-flex justify-content-center col-12'>
                    <form onSubmit={handleSubmit}>
                        <input type="text" id="search" className='search-input' placeholder={`${t("form.search")} ...`} />
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Search